module.exports = __webpack_public_path__ + "img/Shrine.0b871234.png";